module.exports = __webpack_public_path__ + "img/1_029.4821be8a.jpg";